module.exports = __webpack_public_path__ + "static/img/Permiso(8).8feb980.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(8).jpg
// module id = 4xyg
// module chunks = 0